import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ui-initial-route',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class InitialRouteComponent {
}
